import { Navigate } from 'react-router-dom';
import { useAppSelector } from '../hooks/redux';
import { APP_ROUTES } from '../constants';

const RootRedirect = () => {
  const { isAuthenticated } = useAppSelector(state => state.auth);
  return <Navigate to={isAuthenticated ? APP_ROUTES.CHAT : APP_ROUTES.LOGIN} replace />;
};

export default RootRedirect;
